import React from 'react';
import SkeletonFill from '../skeleton-fill';

const EditorHeaderSkeleton = () => (
  <div className="ws-ui-editor-header-skeleton ws-ui-editor-header-skeleton-row">
    <div className="ws-ui-editor-header-skeleton-row ws-ui-editor-header-skeleton__left">
      <div className="ws-ui-editor-header-skeleton__menu ws-ui-editor-header-skeleton-row">
        <div className="ws-ui-editor-header-skeleton-box">
          <SkeletonFill isStatic />
        </div>
        <div className="ws-ui-editor-header-skeleton-box ws-ui-editor-header-skeleton__logo">
          <SkeletonFill isStatic />
        </div>
      </div>
      <div className="ws-ui-editor-header-skeleton__divider" />
      <div className="ws-ui-editor-header-skeleton-box ws-ui-editor-header-skeleton__locales">
        <SkeletonFill isStatic />
      </div>
      <div className="ws-ui-editor-header-skeleton__divider" />
      <div className="ws-ui-editor-header-skeleton__nav ws-ui-editor-header-skeleton-row">
        <div className="ws-ui-editor-header-skeleton-box ws-ui-editor-header-skeleton__nav-item">
          <SkeletonFill isStatic />
        </div>
        <div className="ws-ui-editor-header-skeleton-box ws-ui-editor-header-skeleton__nav-item">
          <SkeletonFill isStatic />
        </div>
        <div className="ws-ui-editor-header-skeleton-box ws-ui-editor-header-skeleton__nav-item">
          <SkeletonFill isStatic />
        </div>
        <div className="ws-ui-editor-header-skeleton-box ws-ui-editor-header-skeleton__nav-item">
          <SkeletonFill isStatic />
        </div>
        <div className="ws-ui-editor-header-skeleton-box ws-ui-editor-header-skeleton__nav-item">
          <SkeletonFill isStatic />
        </div>
      </div>
    </div>
    <div className="ws-ui-editor-header-skeleton-row ws-ui-editor-header-skeleton__right">
      <div className="ws-ui-editor-header-skeleton__divider" />
      <div className="ws-ui-editor-header-skeleton-row ws-ui-editor-header-skeleton__controls">
        <div className="ws-ui-editor-header-skeleton-box">
          <SkeletonFill isStatic />
        </div>
        <div className="ws-ui-editor-header-skeleton-box">
          <SkeletonFill isStatic />
        </div>
        <div className="ws-ui-editor-header-skeleton-box">
          <SkeletonFill isStatic />
        </div>
      </div>
      <div className="ws-ui-editor-header-skeleton__divider" />
      <div className="ws-ui-editor-header-skeleton-row ws-ui-editor-header-skeleton__actions">
        <div className="ws-ui-editor-header-skeleton-box ws-ui-editor-header-skeleton__action">
          <SkeletonFill isStatic />
        </div>
        <div className="ws-ui-editor-header-skeleton-box ws-ui-editor-header-skeleton__action">
          <SkeletonFill isStatic />
        </div>
        <div className="ws-ui-editor-header-skeleton-box ws-ui-editor-header-skeleton__action">
          <SkeletonFill isStatic />
        </div>
        <div className="ws-ui-editor-header-skeleton-box ws-ui-editor-header-skeleton__action">
          <SkeletonFill isStatic />
        </div>
      </div>
    </div>
  </div>
);

export default EditorHeaderSkeleton;
